// Local JPG previews (4 per album) served from /public/albums/.
// Full album link goes to Google Photos.
const localSet = (slug) => [
  `/albums/${slug}-1.jpg`,
  `/albums/${slug}-2.jpg`,
  `/albums/${slug}-3.jpg`,
  `/albums/${slug}-4.jpg`,
];

export const ALBUMS = [
  { id: "pre",       url: "https://photos.app.goo.gl/QJFJm2T3HPkm4hRF8", previews: localSet("pre") },
  { id: "cerimonia", url: "https://photos.app.goo.gl/76mjbJqWegMNvJkF8", previews: localSet("cerimonia") },
  { id: "cocktail",  url: "https://photos.app.goo.gl/cJXj7CwAojgMWtw27", previews: localSet("cocktail") },
  { id: "sopar",     url: "https://photos.app.goo.gl/gJhbkMtVcmhp1UF19", previews: localSet("sopar_festa") },
  { id: "festa",     url: "https://photos.app.goo.gl/b2qLNN7tZtdz2hQa6", previews: localSet("festa_new") },
  { id: "toni",      url: "https://photos.app.goo.gl/7GPjoCgYUgF6ogmN9", previews: localSet("toni") },
  { id: "analog",    url: "https://photos.app.goo.gl/hJjhSQtPu9MZ7nmcA", previews: localSet("analog") },
];
